import React, { useState } from 'react';
import './../assets/css/Events.css';

const customTitles = {
  "event1.jpg": "Arna dana",
  "event5.jpg": "Special Seva Day",
  "meditation_session.jpg": "Deep Meditation Camp",
  "event10.jpg": "Advisory Team Visited Ashram",
  "event11.jpg": "Duck Feeding",
  "event17.jpg": "Dr. P.K. Panigrahi(M.P. Berhampur) and Mahendragiri Santh Visited Ashram",
  "event18.jpg": "Vanavasi Kalyan Karyakarta",
  "event19.jpg": "Alternative LPG Crisis Solution",
  "event21.jpg": "Thali under Mango Tree",
  "event24.jpg": "Sishu Sangam",
  "event25.jpg": "Khel Khel me Bharat",
  "event26.jpg": "Vedant Santh Nirgunanda ke Sath",
  "event27.jpg": "Seminar at Bharat Mandapm, Berhampur",
};

// Automatically import all images
function importAll(r) {
  return r.keys().map((key) => {
    const img = r(key);

    const fileNameWithExt = key.replace('./', ''); // event1.jpg
    const fileName = fileNameWithExt.split('.')[0];

    // Default title (auto)
    const autoTitle = fileName
      .replace(/[-_]/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());

    return {
      src: img,
      title: customTitles[fileNameWithExt] || autoTitle,
    };
  });
}
const images = importAll(
  require.context('../assets/images/events', false, /\.(png|jpe?g|svg)$/)
);

const Events = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className="container">
      <p className="description">
        <strong>Kalinga Ashram:</strong> Celebrate Moments, Cherish Memories
      </p>

      <div className="image-gallery">
        {images.map((item, index) => (
          <div key={index} className="image-card">
            <img
              src={item.src}
              alt={item.title}
              onClick={() => setSelectedImage(item)}
            />
            <p className="image-title">{item.title}</p>
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedImage && (
        <div className="modal-overlay" onClick={() => setSelectedImage(null)}>
          <span className="close-btn">&times;</span>

          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              className="modal-image"
              src={selectedImage.src}
              alt={selectedImage.title}
            />
            <p className="modal-title">{selectedImage.title}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Events;